import { render, staticRenderFns } from "./lotteryDetail.vue?vue&type=template&id=a6660c8e&scoped=true"
import script from "./lotteryDetail.vue?vue&type=script&lang=js"
export * from "./lotteryDetail.vue?vue&type=script&lang=js"
import style0 from "./lotteryDetail.vue?vue&type=style&index=0&id=a6660c8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6660c8e",
  null
  
)

export default component.exports